import { useContext, useEffect, useState } from 'react';
import ComponenteTables from '../../components/tables/ComponentTables/ComponentTables';
import { LoadingContext } from '../../context/Loading/LoadingContext';
import { cadastro, table } from '../../dados/cor/cor.dado';
import { useApi } from '../../hooks/userApi';
import React from 'react';
import EditCores from './EditCores.template';
import { QuadroColor } from 'components/tables/TableComponente/TableComponent.style';
import { SelectChangeEvent } from '@mui/material';

const api = useApi();

export default function Cores() {
  const { setLoading, setLoadingMensagem, setLoadingBtn, setClearLoading }: any = useContext(LoadingContext);
  const [cores, setCores] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(Number(process.env.REACT_APP_PAGINATION_DEFAULT) || 15);
  const [pageTotal, setPageTotal] = useState(0);
  const [like, setLike] = useState('all');
  const [cor, setCor] = useState();
  const [edit, setEdit] = useState<boolean>(false);
  const [allCores, setAllCores] = useState([]);
  const [selectedFilterColumns, setSelectedFilterColumns] = useState<string[]>([]);

  //Parte do modal delete
  const [open, setOpen] = useState(false);
  const [path, setPath] = useState('');
  const [itemExclude, setItemExclude] = useState('');

  const getAllCores = async () => {
    setLoading(true);
    let allData = [];

    try {
      const initialResponse = await api.get(`/cor/paginada/?offset=0&limit=${limit}&like=${like}`);
      if (!initialResponse.status) {
        setLoadingMensagem('Desculpe ocorreu um erro!');
        setLoadingBtn('OK');
        return;
      }

      allData = [...initialResponse.results];
      const totalPages = initialResponse.page_total;

      for (let currentPage = 2; currentPage <= totalPages; currentPage++) {
        const nextPageResponse = await api.get(
          `/cor/paginada/?offset=${limit * (currentPage - 1)}&limit=${limit}&like=${like}`,
        );
        if (!nextPageResponse.status) {
          setLoadingMensagem('Desculpe ocorreu um erro!');
          setLoadingBtn('OK');
          return;
        }

        allData = [...allData, ...nextPageResponse.results];
      }

      setLoading(false);
      setPageTotal(totalPages);
      setAllCores(allData);
    } catch (err) {
      const msg = 'Houve um erro interno, tente mais tarde. ' + err.message;
      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  useEffect(() => {
    setLoading(true);
    api
      .get('/cor/paginada/' + `?offset=${limit * (page - 1)}&limit=${limit}&like=${like}`)
      .then((response) => {
        if (!response.status) {
          setLoadingMensagem('Erro ao carregar página.');
          setLoadingBtn('OK');
          return;
        }
        setCores(response.results);
        setPageTotal(response.page_total);
        setLoading(false);
        setClearLoading();
      })
      .catch((e) => {
        let msg = 'Houve um erro interno, tente mais tarde.' + e.message;
        if (e.code === 'ERR_BAD_REQUEST') msg = 'Usuário e/ou senha inválidos';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
    getAllCores();
  }, [page, like]);

  const handleLike = (value) => {
    setPage(1);
    setLike(value);
  };
  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  //Parte do modal delete
  const handleExcluir = (row: string) => {
    setPath('/cor/');
    setItemExclude(row);
    setOpen(true);
  };

  const handleAtualizar = (row: any) => {
    setCor(row);
    setEdit(true);
  };

  function formataTable(objeto) {
    const novoObjeto = objeto.map((row) => {
      return {
        rowCell: [
          { campo: <QuadroColor cor={row?.hexadecimal}></QuadroColor>, onClick: null, link: false },
          { campo: row?.nome || '-', onClick: null, link: false },
          { campo: row?.hexadecimal || '-', onClick: null, link: false },
          { campo: 'Editar', onClick: () => handleAtualizar(row), link: true },
          { campo: 'Excluir', onClick: () => handleExcluir(row.id), link: true },
        ],
      };
    });
    return novoObjeto;
  }

  const arrList = {
    header: table.header,
    type: table.type,
    rows: formataTable(cores),
  };
  const arrListAll = {
    header: table.header,
    type: table.type,
    rows: formataTable(allCores),
  };

  const handleFilterColumnsChange = (event: SelectChangeEvent<typeof selectedFilterColumns>) => {
    setSelectedFilterColumns(event.target.value as string[]);
  };

  return (
    <>
      {!edit && (
        <ComponenteTables
          table={arrList}
          cadastro={cadastro}
          pageTotal={pageTotal}
          page={page}
          handleChangePage={handleChangePage}
          handleLike={handleLike}
          path={path} // path  do delete
          itemExclude={itemExclude} // id do item
          open={open} // abre modal delete
          setOpen={setOpen} // controle modal delete
          allData={arrListAll}
          selectedFilterColumns={selectedFilterColumns}
          handleFilterColumnsChange={handleFilterColumnsChange}
          showFilterButton={false}
        />
      )}
      {edit && <EditCores dado={cor} setEdit={() => setEdit(false)} />}
    </>
  );
}
